<template>
  <div tabindex="-1" class="line-detail elevation-0" v-if="mission">     
    <v-layout column>                                              
          <template v-if="yo ">       
            <h2 class="body-2 cursor-pointer flex items-center" :style="`color:${gliderColor}`"  @click="coverageIterationMissionUiState.showResult = !coverageIterationMissionUiState.showResult">
              {{$t('Pilot.MissionDrawer.MRS')}} {{glider}}
              <v-icon  :class="{rotate180:coverageIterationMissionUiState.showResult}" class="ml-auto">mdi-chevron-down</v-icon>
            </h2>         
            <div v-if="yo.isUnderWater" >                            
              <strong>{{$t('Pilot.MissionDrawer.Cycle')}} {{yo.yosCycle}} :</strong> {{$t('Pilot.MissionDrawer.UndewaterInfos')}}
            </div>
            <div  v-else>            
            <template>                                
                <table class="mrs-tbl" cellspacing="0">
                  <thead>
                    <tr>          
                      <td>{{$t('Pilot.MissionDrawer.Cycle')}}</td>
                      <td>{{$t('Pilot.MissionDrawer.Battery')}}</td>          
                      <td>{{$t('Pilot.MissionDrawer.Date')}}</td>          
                      <td>{{$t('Pilot.MissionDrawer.Time')}}</td>
                      <td>{{$t('Pilot.MissionDrawer.Latitude')}}</td>
                      <td>{{$t('Pilot.MissionDrawer.Longitude')}}</td>
                    </tr>
                  </thead>
                  <tr>          
                      <td>{{yo.yosCycle}}</td>
                      <td>{{yo.batteries}} %</td>       
                      <td>{{yo.yoGpsDatTime | formatDate('DD/MM/YYYY')}}</td>
                      <td>{{yo.yoGpsDatTime | formatDate('HH:mm:ss UTC')}}</td>
                      <td>{{$options.filters[coordFormatFilter]([yo.yoGpsLon,yo.yoGpsLat],true)}}</td>
                      <td>{{$options.filters[coordFormatFilter]([yo.yoGpsLon,yo.yoGpsLat],false)}}</td>           
                    </tr>
                </table>   
              </template>
              <template>
              
            </template>   
              <template v-if="coverageIterationMissionUiState.showResult" >
                <h2 class="body-2" :style="`color:${gliderColor}`">{{$t('Pilot.MissionDrawer.Computed')}}  {{glider}}</h2>
                <table class="mrs-tbl" cellspacing="0">
                  <thead>
                    <tr>          
                      <td>{{$t('Pilot.MissionDrawer.Distance')}} [m]</td>
                      <td>{{$t('Pilot.MissionDrawer.FlightTime')}} [h:m]</td>
                      <td>{{$t('Pilot.MissionDrawer.COG')}} [°]</td>
                      <td>{{$t('Pilot.MissionDrawer.SOG')}} [m/s]</td>
                      <td>{{$t('Pilot.MissionDrawer.Drift')}} [°]</td>                    
                      <td>{{$t('Pilot.MissionDrawer.MissionDuration')}}</td>
                    </tr>
                  </thead>
                  <tr>
                      <td>{{computedDistance}}</td>
                      <td>{{computedFlightTime}}</td>
                      <td>{{computedCog}}</td>
                      <td>{{computedSog}}</td>
                      <td>{{computedDrift}}</td>
                      <td>{{[mission.yoArray[0].yoGpsDatTime,yo.yoGpsDatTime] | formatDuree($i18n)}}</td> 
                    </tr>
                </table>  
                <h2 class="body-2 text-uppercase" :style="`color:${gliderColor}`" >{{$t('Simulation.Result')}} {{glider}}</h2>                     
                <table class="mrs-tbl" cellspacing="0" >
                  <thead>
                    <tr>          
                      <td>{{$t('Pilot.MissionDrawer.Distance')}}</td>
                      <td>{{$t('Simulation.StartDate')}}</td>
                      <td>{{$t('Simulation.EndDate')}}</td>
                      <td>{{$t('Pilot.MissionDrawer.MissionDuration')}}</td>
                      <td>{{$t('Simulation.CyclesNb')}}</td>
                      <td>{{$t('Simulation.EnergyAvailable')}} (%)</td>                                
                    </tr>
                  </thead>
                 <tr>
                      <td>{{ mission.result.distance_traveled * 1000 | formatDistance }}</td> 
                      <td>{{ missionStartDate | formatDate("DD/MM/YYYY HH:mm:ss") }}</td>
                      <td>{{ mission.result.mission_end_date | formatDate("DD/MM/YYYY HH:mm:ss") }}</td>
                      <td>{{ [new Date(missionStartDate) , new Date(missionCurEndDate)] | formatDuree($i18n) }}</td>
                      <td>{{ nbYos }}</td>
                      <td>{{ energy_available && energy_available.toFixed(2) }} </td>   
                    </tr>
                </table>    
              </template>                                                        
            </div> 
          </template>
          
        <!-- <template  v-else>
          {{$t("Pilot.MissionDrawer.Loading")}}
          <v-progress-linear indeterminate :color="endMissionMode?'secondary':'primary'"  ></v-progress-linear>      
        </template>                 -->
    </v-layout>    
  </div>  
</template>
<script setup lang="ts">  
  import Vue, { ref,computed } from 'vue'
  import { AloMission } from  '@/models/alo/AloMission'   
  import store from '@/store'
  import distance from '@turf/distance'
  import {point,bearingToAzimuth} from '@turf/helpers'
  import bearing from '@turf/bearing'
  import {posModulo} from  '@/utils/modulo'
  import {i18n} from '@/locale/vueI18n'
  import {buildCoverageIterationMissionUiStateId} from '@/models/ui/CoverageIterationMissionUiState'

  const props = defineProps<{mission:AloMission,glider:string,uiid:string}>()
  
  const gliderColor = computed(()=> {
    switch(props.glider){      
      case 'GLIDER2': return '#228be6'
      case 'GLIDER3': return '#40c057'
      case 'GLIDER4': return '#ae3ec9'
      case 'GLIDER5': return '#f03e3e'
      case 'GLIDER6': return '#fcc419'
      case 'GLIDER7': return '#000000'
      default: return 'f76707'
    }
  })

  const coordFormatFilter = computed(()=>store.myGetters.coordFormatFilter)

  const coverageIterationMissionUiStateId = computed(()=>buildCoverageIterationMissionUiStateId(props.uiid,props.glider))
  const coverageIterationMissionUiState = computed(()=>store.myGetters.coverageIterationMissionUiStateByUiid(coverageIterationMissionUiStateId.value))

  const yoIndex = computed(()=> coverageIterationMissionUiState.value?.timelineIndex != -1?coverageIterationMissionUiState.value?.timelineIndex:(props.mission?.yoArray.length-1))

  const yo = computed(() => props.mission?.yoArray?.[yoIndex.value])  
  
  const nextYo = computed(() => {   
    let searchYo = null      
    if(coverageIterationMissionUiState.value?.timelineIndex != -1) {
      let idx = 1
      while(props.mission?.yoArray.length > (yoIndex.value + idx) &&  (searchYo = props.mission?.yoArray[yoIndex.value + idx]).isUnderWater) {
        idx++;
      }        
      if(!searchYo?.isUnderWater) return searchYo?.driftArray?.[0] || searchYo              
    }
    return null
  })

  const canComputeCoord = computed(()=>{
        return nextYo.value?.yoGpsLon && nextYo.value?.yoGpsLat && yo.value?.yoGpsLon && yo.value?.yoGpsLat
  })

  const computedDistance = computed(() => {
    if(canComputeCoord.value){
      return (distance(point([yo.value?.yoGpsLon??0, yo.value?.yoGpsLat??0]),point([nextYo.value?.yoGpsLon??0, nextYo.value?.yoGpsLat??0])) * 1000).toFixed(0)
    }else{
      return '-'
    }
    
  })
  const computedFlightTime = computed(() => {
    if(nextYo.value){
      return Vue.filter("formatDuree")([yo.value.yoGpsDatTime,nextYo.value.yoGpsDatTime],i18n)
    }
    else{
      return '-'
    }
  })
  const computedCog = computed(() => {
    if(canComputeCoord.value){
      return bearingToAzimuth(bearing(point([yo.value.yoGpsLon!, yo.value.yoGpsLat!]),point([nextYo.value?.yoGpsLon??0, nextYo.value?.yoGpsLat??0]))).toFixed(2)
    }
    else{
      return '-'
    }
  })
  const computedDrift = computed(() => {
    if(canComputeCoord.value && yo.value.heading != -9999){
      //@ts-ignore
      return  (posModulo( computedCog.value -  yo.value.heading! + 180,360) - 180).toFixed(2)
    }
    else{
      return '-'
    }
  })
  const computedSog = computed(() => {
    if(canComputeCoord.value){
      return (computedDistance.value??0 / ((nextYo.value?.yoGpsDatTime.getTime()??0 -  yo.value.yoGpsDatTime.getTime())/1000))
    }
    else{
      return '-'
    }
  })

  const missionStartDate = computed(()=>  props.mission?.param?.mission_start_date)
  const missionCurEndDate= computed(()=> (props.mission?.result?.mission_end_date?.length ?? 0) > 0?props.mission?.result?.mission_end_date:props.mission?.result?.current_date)
  const nbYos= computed(()=> props.mission?.result?.cycle_number ?? props.mission?.result?.current_cycle)
  const energy_available= computed(()=> props.mission?.result?.energy_available ?? props.mission?.result?.current_battery)

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2{
  color: var(--primary-color)  
}
</style>
<style>

.mrs-tbl{
  width: 100%;
  font-size: 0.8rem;
}

.cursor-pointer{
  cursor: pointer;
}

table{
  border: 1px solid #ddd;
  border-bottom:0px;
  border-right:0px;    
  max-width: 100%; 
  overflow: auto;
}
thead{
  font-weight: bold;
}
td{
  padding: 0px 2px;
  border:1px solid #ddd;
  border-top:0px;
  border-left:0px;  
  text-align: center;
} 


.line-item .active{
  color: #4caf50!important;
}

.line-item .heading{
  display: flex;
  flex-direction: row;
  align-items: center;  
}
.White>div{
  border: solid 2px #000!important;
}

.line-detail:focus{
    outline: none;
}

.line-detail{
  /*correct elevation bug*/
  -webkit-box-shadow: 0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)!important;
  box-shadow: 0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)!important;
}
</style>
